import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { SizeType } from '@gravity-angular/models';

export interface ConfirmationDialogData {
  title: string;
  description: string;
  emphasis?: string;
  confirmText?: string;
  cancelText?: string;
  showCancelButton?: boolean;
  schemas?: string[];
  tableName?: string;
}

@Component({
  selector: 'app-confirmation-dialog',
  styleUrls: ['./confirmation-dialog.component.scss'],
  templateUrl: './confirmation-dialog.component.html',
  imports: [MatDialogContent, MatDialogActions, MatIcon],
  standalone: true
})
export class ConfirmationDialogComponent implements OnInit {
  title: string;
  description: string;
  emphasis: string = '';
  confirmText: string = 'Confirm';
  cancelText: string = 'Cancel';
  showCancelButton: boolean = true;
  schemas: string[] = [];
  tableName: string = '';
  selectedSchema: string;
  SizeType = SizeType;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData
  ) {}

  ngOnInit(): void {
    this.title = this.data.title;
    this.description = this.data.description;
    this.emphasis = this.data.emphasis || '';
    this.confirmText = this.data.confirmText || 'Confirm';
    this.cancelText = this.data.cancelText || 'Cancel';
    this.showCancelButton =
      this.data.showCancelButton !== undefined
        ? this.data.showCancelButton
        : true;
    this.schemas = this.data.schemas || [];
    this.tableName = this.data.tableName || '';

    // Auto-select schema if only one exists
    if (this.schemas && this.schemas.length === 1) {
      this.selectedSchema = this.schemas[0];
    }
  }

  onConfirm(): void {
    // Return both confirmation status and selected schema
    this.dialogRef.close({
      confirmed: true,
      schema: this.selectedSchema
    });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
